module.exports = __webpack_public_path__ + "static/media/spawn.008390b5.png";